export const KCI_APP_IDS = {
  SHELL: 'kci-core',
  CLARA_REMOTE: 'clara-ai',
  WORKSPACE_APP: 'kci-workspace',
} as const;

export type KCiAppId = (typeof KCI_APP_IDS)[keyof typeof KCI_APP_IDS];
